import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import './index.css'
import React from 'react'
import theme from './theme'
import ReactDOM from 'react-dom'
import Client from './Components/Client'
import Loader from './Components/Loading'
import * as serviceWorker from './serviceWorker'
import { ThemeProvider, StylesProvider } from '@material-ui/styles'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'
import { Security, ImplicitCallback, SecureRoute } from '@okta/okta-react'
import ErrorBoundary from 'react-error-boundary'

const Projects = React.lazy(() => import('./Routes/Projects'))
const Project = React.lazy(() => import('./Routes/Project'))
const Login = React.lazy(() => import('./Routes/Login'))
const Logout = React.lazy(() => import('./Routes/Logout'))
const ErrorPage = React.lazy(() => import('./Routes/ErrorPage'))
const AppCtx = React.lazy(() => import('./Context'))
const ProductData = React.lazy(() => import('./Routes/ProductData'))
const UserSettings = React.lazy(() => import('./Routes/UserSettings'))

const App = () => (
  <StylesProvider injectFirst>
    <ThemeProvider theme={theme}>
      <React.Suspense fallback={<Loader />}>
        <Router>
          <Security
            issuer={process.env.REACT_APP_AUTH_ISSUER}
            client_id={process.env.REACT_APP_AUTH_CLIENTID}
            redirect_uri={window.location.origin + '/implicit/callback'}
          >
            <Client>
              <ErrorBoundary
                FallbackComponent={({ error }) => (
                  <Redirect to={{ pathname: '/error', state: error }} />
                )}
              >
                <Route
                  exact
                  path={['/', '/projects']}
                  render={() => <Redirect to="/projects/1" />}
                />
                <AppCtx>
                  <SecureRoute path="/projects/:page" component={Projects} />
                  <SecureRoute
                    path="/project/:plantId/:projectId"
                    component={Project}
                  />
                  <SecureRoute
                    exact
                    path="/productData"
                    component={ProductData}
                  />
                  <SecureRoute
                    exact
                    path="/userSettings"
                    component={UserSettings}
                  />
                </AppCtx>
              </ErrorBoundary>
              <Route path="/login" component={Login} />
              <Route path="/logout" component={Logout} />
              <Route path="/error" component={ErrorPage} />
              <Route path="/implicit/callback" component={ImplicitCallback} />
            </Client>
          </Security>
        </Router>
      </React.Suspense>
    </ThemeProvider>
  </StylesProvider>
)

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
